module.exports = __webpack_public_path__ + "static/media/bar-chart.489c0a94.svg";